import {
    ObjectivesAndEndpointsSection,
    PlacementPayload,
    StudyEntityType,
    toObjectivesAndEndpointsSection,
} from '@faro/study-designer-model';
import axios from 'axios';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { StudyPathParameter } from '../parameter';

const factory = createStudyEntityHookFactory<ObjectivesAndEndpointsSection>(
    StudyEntityType.ObjectivesAndEndpointsSection
);

export const useObjectivesAndEndpointsSections = factory.list(
    (
        { studyId, ...query }: StudyPathParameter & { revision?: number },
        signal?: AbortSignal
    ): Promise<ObjectivesAndEndpointsSection[]> => {
        return axios
            .get(`/api/study-designer/studies/${studyId}/objectives-and-endpoints-section`, {
                signal,
                params: query,
            })
            .then(response => response.data?.map(toObjectivesAndEndpointsSection) ?? []);
    }
);

export const useObjectivesAndEndpointsSectionUpdate = factory.mutate(
    (entity: ObjectivesAndEndpointsSection) => {
        return axios
            .put(`/api/study-designer/studies/${entity.studyId}/objectives-and-endpoints-section/${entity.id}`, entity)
            .then(response => response.data);
    },
    {
        optimisticUpdate: (objectivesAndEndpointsSection, optimisticData) => {
            return optimisticData.map(x =>
                x.id === objectivesAndEndpointsSection.id ? objectivesAndEndpointsSection : x
            );
        },
    }
);

export const useObjectivesAndEndpointsSectionDelete = factory.mutate((entity: { id: string; studyId: string }) => {
    return axios
        .delete(`/api/study-designer/studies/${entity.studyId}/objectives-and-endpoints-section/${entity.id}`)
        .then(response => response.data);
});

export const useObjectivesAndEndpointsSectionMove = factory.mutate(
    (entity: { id: string; studyId: string; placement: PlacementPayload }) => {
        const { id, studyId, placement } = entity;
        return axios
            .put(
                `/api/study-designer/studies/${studyId}/objectives-and-endpoints-section/${id}/actions/move`,
                placement
            )
            .then(response => response.data);
    }
);
